// Add class to body-element on tab click

const BlockFAQ = () => {
  const self = {
    init () {
      self.addEventListeners()
    },
    onClick (e) {
      if (!e.target.classList.contains('BlockFAQ__button')) return
      e.target.closest('.BlockFAQ__question').classList.toggle('is-active')
    },
    addEventListeners () {
      document.addEventListener('click', self.onClick)
    }
  }

  return self
}

export default BlockFAQ
